var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.config.mine_version == '1.0')?_c('Mine_index'):_c('Mine_new')
}
var staticRenderFns = []

export { render, staticRenderFns }